export default {
    data: () => ({
        urlFilters: {}
    }),
    watch: {
        filters: {
            handler: function(newValue) {
                if (newValue) {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);

                    filters.forEach(filter => {
                        let key = Object.keys(filter)[0];
                        const value = urlParams.has(key) ? urlParams.get(key).split(',') : [];

                        this.$set(this.urlFilters, key, value);
                    })
                }
            },
            immediate: true,
            deep: true
        },
        urlFilters: {
            handler: function(newValue) {
                if (newValue) this.syncUrlParams();
            },
            immediate: false,
            deep: true
        }
    },
    methods: {
        syncUrlParams() {
            let validParameters = {};
            // Filter parameters that has one or more values
            Object.keys(this.urlFilters).forEach(key => {
                if (this.urlFilters[key] && this.urlFilters[key].length > 0) {
                    validParameters[key] = this.urlFilters[key];
                }
            });
            // Update url parameters
            const parameters = new URLSearchParams(validParameters).toString();
            const fullUrl = window.location.origin + window.location.pathname + '?' + parameters;
            window.history.replaceState('', '', fullUrl);
            this.$emit('resetPage');
            this.$emit('getData', true);
        }
    }
}